import {
  computed,
  inject,
} from '@vue/composition-api';

export default () => {
  const config = inject('config');
  const productName = inject('productName');
  const helpers = inject('helpers');
  const {
    isCarMinimiseHelptext,
    isVanMinimiseHelptext,
    isBikeMinimiseHelptext,
    isHomeMinimiseHelptext,
  } = inject('abTastyControllerUI');

  // COMPUTED
  const isExperimentMinimiseHelptextCar = computed(() => isCarMinimiseHelptext.value && helpers.isQuotezonePartner(config.partner));
  const isExperimentMinimiseHelptextVan = computed(() => isVanMinimiseHelptext.value && helpers.isQuotezonePartner(config.partner));
  const isExperimentMinimiseHelptextBike = computed(() => isBikeMinimiseHelptext.value && helpers.isQuotezonePartner(config.partner));
  const isExperimentMinimiseHelptextHome = computed(() => isHomeMinimiseHelptext.value && helpers.isQuotezonePartner(config.partner));

  const isExperimentMinimiseHelptext = computed(() => {
    switch (productName) {
      case 'car':
        return isExperimentMinimiseHelptextCar.value;
      case 'van':
        return isExperimentMinimiseHelptextVan.value;
      case 'bike':
        return isExperimentMinimiseHelptextBike.value;
      case 'home':
        return isExperimentMinimiseHelptextHome.value;
      default:
        return false;
    }
  });

  return {
    isExperimentMinimiseHelptext,
  };
};
